import * as React from "react";
import Button from "@material-ui/core/Button";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";

import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionDetails from "@material-ui/core/ExpansionPanelDetails";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
// import Typography from "@material-ui/core/Typography";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DoneIcon from "@material-ui/icons/Done";
import Grid from "@material-ui/core/Grid";

import Component from "../../../../AbstractComponent";
import Constants from "../../../../../Action/Constants";
import { ChargeInterface } from "../../../../../Entity/Entities/Charge/ChargeInterface";
import BillDetails from "./BillDetails";
//import { formatDate } from "../utils/formatDate";

export default class Finish extends Component {
  public state = {
    sendEmail: false,
  };

  constructor(public props) {
    super(props);

    this.onFinish = this.onFinish.bind(this);
    this.onBack = this.onBack.bind(this);
    this.renderTenantsDistributionTable = this.renderTenantsDistributionTable.bind(this);
    this.renderAccordionHeader = this.renderAccordionHeader.bind(this);
  }

  /* under construction: now a copy of onNextStep */
  public onFinish = () => {
    this.props.setState({
      ...this.props.state,
      ...this.state,
      activeStep: 4,
    });

      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_CREATE_START,
        payload: {
          charge: this.props.state,
          variation: 'settle-bill',
        },
        onSuccess: (charge: ChargeInterface) => {
          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          this.setState({
            charge: charge,
            requestFailed: false,
            showBackButton: false,
            activeStep: 4,
            showLoader: false,
            chargeCreatedSuccessfully: true
          });
        },
        onError: (err) => {
          return this.setState({
            hasModifiedData: true,
            requestFailed: true,
            errors: err,
            showLoader: false,
            chargeCreatedSuccessfully: false,
          });
        }
      });
  };

  public onBack = () => {
    this.props.setState({
      ...this.props.state,
      ...this.state,
      activeStep: 3,
    });
  };

  public renderAccordionHeader = () => {
    return (
      <Grid container style={{padding:"0 2px", fontWeight:100, color:"gray"}}>
        <Grid item xs={2} style={{padding:"0px 12px 6px"}}>
        {this.trans("coach/new-bill-settlement/steps/finish/tenants/header/unit")}
        </Grid>
        <Grid item xs={4} style={{padding:"0px 12px 6px"}}>
          {this.trans("coach/new-bill-settlement/steps/finish/tenants/header/tenant")}
        </Grid>
        <Grid item xs={2} style={{padding:"0px 12px 6px", display:"flex", justifyContent:"right"}}>
          {this.trans("coach/new-bill-settlement/steps/finish/tenants/header/to-pay")}
        </Grid>
        <Grid item xs={2} style={{padding:"0px 12px 6px", display:"flex", justifyContent:"right"}}>
          {this.trans("coach/new-bill-settlement/steps/finish/tenants/header/deposited")}
        </Grid>
        <Grid item xs={2} style={{padding:"0px 12px 6px", display:"flex", justifyContent:"right"}}>
          {this.trans("coach/new-bill-settlement/steps/finish/tenants/header/remains-to-settle")}
        </Grid>
      </Grid>
    )
  }

  public renderTenantsDistributionTable() {
    if (!this.props.state.unit_calculations) {
      return null;
    }

    return this.props.state.unit_calculations.units.map((unit) =>
      !this.props.state.unit_calculations.unit_percentages[unit.id] ? null :
      (this.props.state.unit_calculations.tenants_by_unit[unit.id] || [])
      .map((tenant, idx) => (
            <Accordion key={`${unit.id}_${tenant.id}_${idx}`}>

                  {/*** Summary of unit/tenant/to-pay ***/}

              <AccordionSummary style={{backgroundColor:"#f8f8f8"}}>
                <Grid container spacing={3} justify="space-between">
                  <Grid item xs={2}>
                    <div style={{ fontSize: "1.2", fontWeight: "bold" }}>{this.trans(unit?.type?.label) + ' ' + unit.unitNumber}</div>
                  </Grid>
                  <Grid item xs={4}>
                    <div style={{ fontSize: "1.2", fontWeight:"bold"}}>{tenant.displayName}</div>
                  </Grid>
                  <Grid item xs={2}>
                    <div style={{ fontSize: "1.2", fontWeight:"bold", display:"flex", justifyContent:"right"}}>
                      {(this.props.state.unit_calculations.to_pay_by_units_by_tenants[unit.id][tenant.id] || 0).toFixed(2)}{" "}EUR
                    </div>
                  </Grid>
                  <Grid item xs={2}>
                    <div style={{ fontSize: "1.2", fontWeight:"bold", display:"flex", justifyContent:"right"}}>
                      {(this.props.state.unit_calculations.deposited_by_units_by_tenants[unit.id][tenant.id] || 0).toFixed(2)}{" "}EUR
                    </div>
                  </Grid>
                  <Grid item xs={2}>
                    <div style={{ fontSize: "1.2", fontWeight:"bold", display:"flex", justifyContent:"right"}}>
                      {((this.props.state.unit_calculations.to_pay_by_units_by_tenants[unit.id][tenant.id] || 0) - (this.props.state.unit_calculations.deposited_by_units_by_tenants[unit.id][tenant.id] || 0)).toFixed(2)}{" "}EUR
                    </div>
                  </Grid>
                </Grid>
              </AccordionSummary>

              {/*** List of unit/tenant/deposits ***/}

              <AccordionDetails style={{ flexDirection: "column", backgroundColor: "#fcfcfc"}}>
                <Grid container direction="column">
                  {/**
                  {this.props.state.unit_calculations.intersecting_contracts_by_unit[unit.id]
                    .filter((contract) => this.props.state.unit_calculations.contracts_by_tenant[tenant.id].find((c) => c.id === contract.id))
                    .map((contract, idx) => ( 
                  **/}
                  {this.props.state.unit_calculations.periods_by_tenant[tenant.id]
                    .sort( (a,b) => a.firsDate - b.firstDate)
                    .map( (period, idx) => (
                      <Grid item xs={12} key={idx}>
                        <Grid container direction="column">
                          {/**
                          {(this.props.state.unit_calculations.periods_by_contract[contract.id])
                            .sort( (a,b) => a.firstDate < b.firstDate)
                            .map((period, idx) => (
                          **/}
                            <Grid item xs={12} key={idx}>
                              <Grid container spacing={3} direction="row" style={{color:"gray"}}>
                                <Grid item xs={2}>
                                  <div style={{ opacity: 0 }}>{tenant.id}</div>
                                </Grid>
                                <Grid item xs={4} style={{display:"flex", justifyContent:"right"}}>
                                    {this.formatter.formatDate(period.firstDate) + "  -  " + this.formatter.formatDate(period.lastDate)}
                                </Grid>
                                <Grid item xs={2} style={{display:"flex", justifyContent:"right"}}>
                                    {(period.to_pay || 0).toFixed(2)} EUR
                                </Grid>
                                <Grid item xs={2} style={{display:"flex", justifyContent:"right"}}>    
                                    {(period.deposited || 0).toFixed(2)} EUR
                                </Grid>
                                <Grid item xs={2} style={{display:"flex", justifyContent:"right"}}>
                                    {(period.to_pay - period.deposited || 0 ).toFixed(2)}{" "}EUR
                                </Grid>
                              </Grid>
                            </Grid>

                            {/**
                          ))} **/}

                        </Grid>
                      </Grid>
                    ))}
                </Grid>
              </AccordionDetails>
            </Accordion>
          ))
    );
  }

  public render() {
    return (
      <div className="coach_newBillSettlement_step_wrapper">
        <div className="coach_newBillSettlement_step_title">
          {this.props.state.address?.displayName ?? ""}
        </div>
        <BillDetails {...this.props} />

        <div className="coach_newBillSettlement_step_section_content">
          <div className="coach_newBillSettlement_step_section_header">
            <div className="coach_newBillSettlement_step_section_header_title">
              {this.trans(
                "coach/new-bill-settlement/steps/finish/tenants/title"
              )}
            </div>
          </div>
          <div className="coach_newBillSettlement_step_section_content">
            {this.renderAccordionHeader()}
            {this.renderTenantsDistributionTable()}
          </div>
        </div>

        <div className="coach_newBillSettlement_actionButtons">
          <Button
            variant="contained"
            onClick={this.onBack}
            startIcon={<ArrowBackIos />}
          >
            {this.trans("coach/new-bill-settlement/action-buttons/back")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onFinish}
            endIcon={<DoneIcon />}
          >
            {this.trans("coach/new-bill-settlement/action-buttons/finish")}
          </Button>
        </div>
      </div>
    );
  }
}
